import SchedulingLimits from 'components/SchedulingLimits'
import Translation from 'components/Translation'
import { AuthContext, useAuth } from 'context/AuthContext'
import { useTenantContext } from 'context/TenantContext'
import { useEffect } from 'react'
import { createModal } from '../ModalFactory'
import { ModalWrapper } from '../ModalWrapper'

const ModalProvider = createModal(
    AuthContext,
    'GlobalSchedulingLimitsModal',
    () => (
        <>
            <i className="feather feather-plus mr-4" />
            <span className="circular">Global Scheduling Limits</span>
        </>
    ),
    () => (
        <span className="inline-block w-6 h-6 text-primary text-center font-extralight">
            <i className="feather feather-chevron-left " />
        </span>
    )
)
export const GlobalSchedulingLimitsModalOpener = ModalProvider.Opener
export const GlobalSchedulingLimitsModalCloser = ModalProvider.Closer

export default function GlobalSchedulingLimitsModal() {
    const { GlobalSchedulingLimitsModal } = useAuth()
    const { tenant } = useTenantContext()
    const { setAttributes } = GlobalSchedulingLimitsModal
    const restriction_template = {
        bookMaxDaysInAdvance: 0,
        bookMinBeforeStartTime: 0,
        canCancel: false,
        canResched: false,
        cancelMinBeforeStartTime: 0,
        lookupId: tenant?.id as string,
        reschedMinBeforeStartTime: 0,
        tenantId: tenant?.id as string,
        type: 'TENANT',
    }

    useEffect(() => {
        if (!GlobalSchedulingLimitsModal.is_open) {
            setAttributes({})
        }
    }, [GlobalSchedulingLimitsModal.is_open])

    const handleOnSaveClick = function () {
        setAttributes({
            refetch: true,
        })
        GlobalSchedulingLimitsModal.close()
    }

    return (
        <ModalProvider.Visible>
            <ModalWrapper className="xl:w-wider">
                <div className="bg-white shadow-3xl overflow-x-hidden overflow-y-auto sm:rounded-md mx-auto my-4 relative border-2 border-gray-100 flex flex-col">
                    <div className="flex px-4 text-gray-500 z-10 pt-4 bg-opacity-30 pb-3 bg-primary-lighter">
                        <div>
                            <span className="inline-block self-center text-lg text-primary-dark">
                                <GlobalSchedulingLimitsModalCloser className="self-center" />
                                <Translation
                                    render_as="span"
                                    className="circular"
                                    content_key="global_scheduling_limits"
                                />
                            </span>
                        </div>
                    </div>
                    <div className="p-10 w-full">
                        <SchedulingLimits
                            restriction_template={restriction_template}
                            onCancel={GlobalSchedulingLimitsModal.close}
                            onSave={handleOnSaveClick}
                            is_global={true}
                        />
                    </div>
                </div>
            </ModalWrapper>
        </ModalProvider.Visible>
    )
}
